@if (page$ | async; as page) { @if (isLoading) {
<div>
  <syn-loader />
</div>
} @else {
<div class="container mb-2">
  <div class="row pt-2 mt-3">
    <h3 class="col-8">Candidats</h3>
    <syn-candidate-actions class="col-4 d-block d-lg-none" (_create)="createCandidate()" />
  </div>
</div>
<div class="d-flex flex-column container">
  <div class="headbar row">
    <div class="filters col-10">
      <syn-searchbar
        (changeSearch)="onSearchFilterChange($event)"
        (launchSearch)="applyFilter()"
        (resetSearch)="resetSearch()" />
      <p>Filtrer par :</p>
      <syn-filter [filterBy]="'Groupe'" (filter)="onFilterGroupChange($event)" />
      <syn-filter [filterBy]="'Examen'" (filter)="onFilterAssessmentChange($event)" />
      <syn-filter [filterBy]="'Statut'" (filter)="onFilterStatusChange($event)" />
    </div>
    <syn-candidate-actions
      class="col-2 d-none d-lg-block"
      (_create)="createCandidate()"
      [remindDisabled]="numberOfCandidates === 0" />
  </div>
  @if (page.content.length) {
  <div>
    <syn-candidates-table
      [page]="page"
      [isSelectionTable]="true"
      [isGroupDetails]="false"
      [canDeleteCandidate]="true" />
  </div>
  } @else {
  <syn-empty-page message="La liste des candidats est vide" />
  }
  <syn-pagination [page]="page" queryParamsHandling="merge" />
</div>
} }
